<template>
	<p
		ref="component"
		:class="[
			settings.fixedClasses,
			size ? `nk-text--${size}` : null,
			size ? settings.sizes[size] : null,
			color ? settings.colors[color] : null,
			color ? 'has-color' : null,
			weight ? settings.weights[weight] : null,
			maxLines ? settings.lineClamps[maxLines] : null,
			groupHover ? `group-hover:${groupHover}` : null,
			groupFocus ? `group-focus:${groupFocus}` : null,
			noMargin ? 'm-0' : null,
			,
		]"
	>
		<slot />
	</p>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkText');

defineProps({
	size: {
		type: String,
		default: null,
		required: false,
	},
	color: {
		type: String,
		default: null,
		required: false,
	},
	maxLines: {
		type: String,
		required: false,
		default: null,
	},
	groupHover: {
		type: String,
		default: 'text-current',
		required: false,
	},
	groupFocus: {
		type: String,
		default: 'text-current',
		required: false,
	},
	weight: {
		type: String,
		default: null,
		required: false,
	},
	truncate: {
		type: Boolean,
		default: false,
		required: false,
	},
	noMargin: {
		type: Boolean,
		default: false,
		required: false,
	},
});
</script>
